import { UserInformation } from "./userInformation";

export class Reviewer {
  user!: UserInformation;
  isApprover: boolean | true;
  relatedScope: string;

  constructor(userinfo: UserInformation, isApprover: boolean, relatedScope: string) {
    this.user = userinfo;
    this.isApprover = isApprover;
    this.relatedScope = relatedScope;
  }
}
